(function (angular, app) {
    "use strict";
    
   angular.module(app.modules.member.name)
      .factory(app.modules.member.services.search, MemberSearchFactory);
      
   MemberSearchFactory.$inject = [app.modules.common.services.http
       , app.modules.common.constants.appsettings
       , app.modules.common.services.functions
   ];
   
   function MemberSearchFactory($http
       , ggSettings
       , ggFunctions
       ) {
      
      var _searchTypes = {
         byName : 1
         , byFriend : 2
         , byClub : 3
         , byGroup : 4
      }
      
       // Member Search
      var _search = {
          fetchMemberDetail : function(memberId){
             var apipath = ggSettings.gnapi.root + ggSettings.gnapi.member.detail + "(" + memberId + ")";
             var exp = "?expand=handicap,membership"
              return $http.get(apipath, {});
          } 
          , fetchMemberSearch: function (data) {
              // Build Search
              var qry = "?$top=50&$filter=";
              var exp = "";
              var ord = "&$orderby=lastName,firstName"

            var isFilter = false;
            if (data.name) {
                var name = data.name.trim();
                var lastname = "";
                var firstname = "";
                if (name.indexOf(",") > 0) {
                    // LastName, FirstName
                    firstname = name.substring(name.indexOf(",") + 1, name.length).trim();
                    lastname = name.substring(0, name.indexOf(",")).trim();
                    qry = qry + "startswith(lastName,'" + lastname + "')"
                    qry = qry + " and startswith(firstName,'" + firstname + "')"
                    } else {
                    if (isNaN(name)) {
                        // Last Name Only
                        qry = qry + "startswith(lastName,'" + name + "')"
                    } else {
                        // Handicap Id
                        qry = qry + "id eq " + name;
                    }

                }
                isFilter = true;
            }


            if (data.firstName) {
               if (isFilter) {
                  qry += " and "
               }
               qry = qry + "startswith(firstName,'" + data.firstName.trim() + "')"
               isFilter = true;
            }
            if (data.lastName) {
               if (isFilter) {
                  qry += " and "
               }
               qry = qry + "startswith(lastName,'" + data.lastName.trim() + "')"
               isFilter = true;
            }
            if (data.handicapId) {
               if (isFilter) {
                  qry += " and "
               }
               qry = qry + "id eq " + data.handicapId;
               isFilter = true;
            }
            if (data.email) {
               if (isFilter) {
                  qry += " and "
               }
               qry = qry + "email eq '" + data.email.trim() + "'"
               isFilter = true;
            }
            if (data.gender) {
                if (isFilter) {
                    qry += " and "
                }
                qry = qry + "gender eq '" + data.gender.trim() + "'"
                isFilter = true;
            }
            if (data.city) {
                isFilter = true;
                if (isFilter) {
                    qry += " and "
                }
                qry = qry + "address/city eq '" + data.city.trim() + "'"
                isFilter = true;
            }
            if (data.regioncode) {
                isFilter = true;
                if (isFilter) {
                    qry += " and "
                }
                qry = qry + "address/region eq '" + data.regioncode.trim() + "'"
                isFilter = true;
            }

              // Build Request
            var apipath = ggSettings.gnapi.root + ggSettings.gnapi.member.search;
              // Fetch
              return $http.get(apipath + qry + exp +  ord, {});
          }
          , fetchMemberSearchByGroup: function (data) {
             // Build Search
             var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.membership;
             var qry = "?$filter=groupId eq " + data.groupId;
             var exp = "&$expand=member($expand=createdBy($select=id)),handicaps";
             var ord = "&$orderby=member/lastName";

             if (data.name) {
                var name = data.name.trim();
                var lastname = "";
                var firstname = "";
                if (name.indexOf(",") > 0) {
                   // LastName, FirstName
                   firstname = name.substring(name.indexOf(",") + 1, name.length).trim();
                   lastname = name.substring(0, name.indexOf(",")).trim();
                   qry = qry + " and startswith(member/lastName,'" + lastname + "')"
                   qry = qry + " and startswith(member/firstName,'" + firstname + "')"
                } else {
                   if (isNaN(name)) {
                      // Last Name Only
                      qry = qry + " and startswith(member/lastName,'" + name + "')"
                   } else {
                      // Handicap Id
                      qry = qry + " member/id eq " + name;
                   }

                }
             }
             // Fetch


             return $http.get(apipath + qry + exp + ord, {});
          }
         , fetchMemberSearchByClub: function (data) {
            // Build Search
            var apipath = ggSettings.gnapi.root + ggSettings.gnapi.club.memberships;
            var qry = "?$filter=clubId eq " + data.clubId + "and membershipStatus eq GN.ClubMembershipStatus'Active' and (membershipType eq GN.ClubMembershipType'Partial' or membershipType eq GN.ClubMembershipType'Full')";
            var exp = "&$expand=member($expand=createdBy($select=id))";
            var ord = "&$orderby=member/lastName";

            return $http.get(apipath + qry + exp + ord, {});
         }
         , fetchMemberSearchByFriends: function (data) {
            // Build Search
            var apipath = ggSettings.gnapi.root + ggSettings.gnapi.member.friends;
            apipath = apipath.replace("(id)", "(" + data.memberId + ")");
            var qry = "($select=id,networkId,firstName,lastName,gender,email,address,photo)";
            var exp = "";
            var ord = "";
            // Fetch
            return $http.get(apipath + qry + exp + ord, {}).then(function (data) {
               if (data && data.status == "200") {
                  var ret = {
                     status: "200"
                     , data : {
                        value : data.data.friends
                     }
                  }
                  return ret;
               }
            });
         }
         , fetchHandicapSearch: function (data) {
              // Build Search
             var qry = "?$top=50&$filter=club/type+ne+'NonHandicapping' and club/isActive eq true and isPrimary eq true and membershipStatus eq GN.ClubMembershipStatus'Active' and (membershipType eq GN.ClubMembershipType'Partial' or membershipType eq GN.ClubMembershipType'Full')";
              var exp = "&$expand=member";
              var ord = "&$orderby=member/lastName,member/firstName"

              if (data.name) {
                  var name = data.name.trim();
                  var lastname = "";
                  var firstname = "";
                  if (name.indexOf(",") > 0) {
                      // LastName, FirstName
                      firstname = name.substring(name.indexOf(",") + 1, name.length).trim();
                      lastname = name.substring(0, name.indexOf(",")).trim();
                      qry = qry + " and startswith(member/lastName,'" + lastname + "')"
                      qry = qry + " and startswith(member/firstName,'" + firstname + "')"
                  } else {
                      if (isNaN(name)) {
                          // Last Name Only
                          qry = qry + " and startswith(member/lastName,'" + name + "')"
                      } else {
                          // Handicap Id
                          qry = qry + " and member/id eq " + name;
                      }

                  }
              }


              if (data.firstName) {
                  qry = qry + " and startswith(member/firstName,'" + data.firstName.trim() + "')"
              }
              if (data.lastName) {
                  qry = qry + " and startswith(member/lastName,'" + data.lastName.trim() + "')"
              }
              if (data.handicapId) {
                  qry = qry + " and member/id eq " + data.handicapId;
              }
              if (data.email) {
                  qry = qry + " and member/email eq '" + data.email.trim() + "'"
              }
              if (data.gender) {
                  qry = qry + " and member/gender eq '" + data.gender.trim() + "'"
              }
              if (data.city) {
                  qry = qry + " and member/address/city eq '" + data.city.trim() + "'"
              }
              if (data.regioncode) {
                  qry = qry + " and member/address/region eq '" + data.regioncode.trim() + "'"
              }

              // Build Request
              var apipath = ggSettings.gnapi.root + ggSettings.gnapi.club.memberships;
              // Fetch
              return $http.get(apipath + qry + exp + ord, {}).then(function (data) {
                  var res = data.data.value;
                  var ret = {
                      status: "200"
                      , data : {
                          value: []
                    }
                  }
                  for (var r = 0; r < res.length; r++) {
                      ret.data.value.push(res[r].member);
                  }
                  return ret;
              }, function (fail) {
                  return fail;
              });
          }
      }
      var service = {
         searchTypes : _searchTypes
         , search : _search
      }
      
      return service;
   }
}(angular, app));

